import { useMemo } from 'react';
import type { Conversation, Message } from '@cyphex/types';
import { buildTimelineRows } from '../lib/grouping';
import type { OutboxItem, TimelineRow } from '../types';

/**
 * Turns the raw page list into render rows once per data change. Everything
 * downstream (the virtualiser, every bubble) reads a memoised array, so
 * scrolling never recomputes grouping.
 */
export function useTimelineRows(
  messages: readonly Message[],
  pending: readonly OutboxItem[],
  conversation: Conversation | null,
): TimelineRow[] {
  const pendingById = useMemo(
    () => new Map(pending.map((item) => [item.clientMsgId, item])),
    [pending],
  );

  return useMemo(
    () =>
      buildTimelineRows({
        messages,
        pending: pendingById,
        firstUnreadSeq: conversation?.self.firstUnreadSeq ?? null,
        unreadCount: conversation?.self.unreadCount ?? 0,
      }),
    [conversation?.self.firstUnreadSeq, conversation?.self.unreadCount, messages, pendingById],
  );
}
